export enum EditorLayout {
  PRESCRIBER = 'prescriber',
  PHARMACY = 'pharmacy',
}
